import { DiscountType } from "../../models";
export const getBundlePriceEditorData = service => {
  var _service$bundle;
  return {
    bundleRate: service.cost.pricingType === 'fixed' || service.cost.pricingType === 'variable' ? service.cost.price.toNumber() : 0,
    discount: service.cost.discount ? service.cost.discount.amount().toNumber() : '',
    discountType: DiscountType.Percent,
    includedServiceRates: ((_service$bundle = service.bundle) === null || _service$bundle === void 0 ? void 0 : _service$bundle.services.reduce((acc, service) => {
      if (service.serviceTemplateId) acc[service.serviceTemplateId] = service.rate.toNumber();
      return acc;
    }, {})) || {}
  };
};